import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { columns } from './services-grid-columns';
import { servicesApiKeyStore } from '../../../../api/masters/services-api-key-store';
import DeleteIcon from '@mui/icons-material/Delete';
import { useEffect, useState } from 'react';
import { useLoadData } from '../../../../hooks/useLoadData';
import { ApiResponse } from '../../../../models/api-response';
import { Service } from '../../../../models/masters/service';
import { serviceBundleApiKeyStore } from '../../../../api/service-bundle-api-key-store';
import { Button, IconButton, Tooltip, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { ServiceBundle } from '../../../../models/service-bundle';
import { ServicesDetails } from './service-details';
import { ServiceBundleDialog } from '../service-bundle/service-bundle.dialog';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { LoadingIndicator } from '../../../../components/loading-indicator.component';
import { useDeleteData } from '../../../../hooks/useDeleteData';
import { UserPermissionName } from '../../../../models/user-permission-name';
import { GuardedComponent } from '../../../../components/guarded-component';
import { useAuthorize } from '../../../../hooks/use-authorize';
import { GridColumnConfig, GridPreference } from '../../../../models/gridCoumnConfig';
import { gridApiKeyStore } from '../../../../api/grid-api-key-store';
import { useSaveData } from '../../../../hooks/useSaveData';
import { State } from '@progress/kendo-data-query';
import useDebounce from '../../../../hooks/use-debounce';

interface CellProps {
  bundleService: any;
}

interface CustomGridCellProps {
  field: string;
}
interface OfficeTabProps {
  unitID: number;
  isCompleted?: boolean;
}
export const ServicesBundleTab = ({ unitID, isCompleted }: OfficeTabProps) => {
  const [openServiceBundle, setOpenServiceBundle] = useState(false);
  const [openServiceList, setOpenServiceList] = useState(false);
  const [value, setValue] = useState('create');
  const [splitID, setSplitID] = useState(0);
  const [editItem, setEditItem] = useState<ServiceBundle>();
  const { data, isLoading, refetch } = useLoadData<ApiResponse<Service[]>>(
    serviceBundleApiKeyStore.getAllServiceBundle(0, 0, unitID)
  );
  const [totalInvoiceAmount, setTotalInvoiceAmount] = useState<number>(0);
  const [currentItemID, setCurrentItemID] = useState<number>(0);
  const [isOpen, setIsOpen] = useState(false);
  const {
    isLoading: isLoadingBundle,
    isError,
    error,
    mutateAsync: deleteBundle,
  } = useDeleteData(serviceBundleApiKeyStore.deleteServicBundle(currentItemID));

  const handleOpenBundleDialog = () => {
    setOpenServiceBundle(true);
    setValue('create');
    setEditItem(undefined);
  };
  const handleCloseBundleDialog = () => {
    setOpenServiceBundle(false);
  };

  const handleEditClick = (bundleService: any) => {
    setValue('edit');
    setEditItem(bundleService);
    setOpenServiceBundle(true);
  };

  const handleCountCellClick = (bundleService: any) => {
    setSplitID(bundleService?.typeID);
    setOpenServiceList(true);
  };

  useEffect(() => {
    const calculateTotalInvoiceAmount = () => {
      const total = data?.data?.reduce((acc, item) => {
        return acc + (Number(item.invoiceAmount) || 0);
      }, 0);
      setTotalInvoiceAmount(!total ? 0 : total);
    };
    if (data) {
      calculateTotalInvoiceAmount();
    }
  }, [data]);

  const BundleItem = ({ bundleService }: CellProps) => {
    return (
      <td>
        <Typography
          variant="body1"
          style={{
            fontWeight: bundleService?.itemType === 'Bundle' || !bundleService?.itemType ? 'bold' : '',
            marginLeft: bundleService?.itemType === 'Bundle' || !bundleService?.itemType ? 0 : 17,
          }}
        >
          {bundleService?.typeName}
        </Typography>
      </td>
    );
  };

  const openDialog = (id: any) => {
    setIsOpen(true);
    setCurrentItemID(id);
  };

  const FooterCell = () => {
    return (
      <td>
        <Typography variant="body1" style={{ fontWeight: 'bold' }}>
          Total: {!!totalInvoiceAmount && `$${totalInvoiceAmount?.toFixed(2)}`}
        </Typography>
      </td>
    );
  };

  const SplitAmount = ({ bundleService }: CellProps) => {
    return (
      <td>
        <Typography variant="body1" style={{ cursor: 'pointer' }}>
          {!!bundleService?.splitAmount && `$${bundleService?.splitAmount}`}
        </Typography>
      </td>
    );
  };

  const BundlePrice = ({ bundleService }: CellProps) => {
    return (
      <td>
        <Typography variant="body1" style={{ cursor: 'pointer' }}>
          {!!bundleService?.bundlePrice && `$${bundleService?.bundlePrice}`}
        </Typography>
      </td>
    );
  };

  const InvoiceAmount = ({ bundleService }: CellProps) => {
    return (
      <td>
        <Typography variant="body1" style={{ cursor: 'pointer' }}>
          {!!bundleService?.invoiceAmount && `$${bundleService?.invoiceAmount}`}
        </Typography>
      </td>
    );
  };
  const CountItem = ({ bundleService }: CellProps) => {
    return (
      <td>
        <IconButton aria-label="edit" onClick={() => handleCountCellClick(bundleService)}>
          <Typography variant="body1" style={{ cursor: 'pointer' }}>
            {bundleService?.itemType === 'Split' && bundleService?.servicesCount}
          </Typography>
        </IconButton>
      </td>
    );
  };

  const isEditPermission = useAuthorize([UserPermissionName.EDIT_SERVICE_BUNDLE]);
  const isDeletePermission = useAuthorize([UserPermissionName.DELETE_SERVICE_BUNDLE]);

  const EditCell = ({ bundleService }: CellProps) => {
    return (
      <td style={{ display: 'flex' }}>
        {bundleService?.itemType === 'Bundle' && (
          <>
            <GuardedComponent requiredPermissions={[UserPermissionName.EDIT_SERVICE_BUNDLE]}>
              <IconButton
                disabled={!bundleService?.isEditable}
                aria-label="edit"
                onClick={() => handleEditClick(bundleService)}
              >
                <Tooltip title={<Typography variant="body1">Edit</Typography>}>
                  <EditIcon className="btnEdit" />
                </Tooltip>
              </IconButton>
            </GuardedComponent>
            {!isEditPermission && (
              <Tooltip title={<Typography variant="body1">You do not have edit permission</Typography>}>
                <EditIcon style={{ color: 'gray' }} className="btnEdit" />
              </Tooltip>
            )}
            <GuardedComponent requiredPermissions={[UserPermissionName.DELETE_SERVICE_BUNDLE]}>
              <IconButton style={{ padding: 5 }} aria-label="delete" onClick={() => openDialog(bundleService?.typeID)}>
                <Tooltip title={<Typography variant="body1">Delete</Typography>}>
                  <DeleteIcon className="btnDelete" />
                </Tooltip>
              </IconButton>
            </GuardedComponent>
            {!isDeletePermission && (
              <Tooltip title={<Typography variant="body1">You do not have delete permission</Typography>}>
                <DeleteIcon style={{ color: 'gray' }} className="btnDelete" />
              </Tooltip>
            )}
          </>
        )}
      </td>
    );
  };

  const CustomGridCell = ({ field }: CustomGridCellProps): ((dataItem: any) => JSX.Element) | undefined => {
    if (field === 'typeName') {
      // Return a function that takes a data item and returns a JSX element
      return (dataItem: any) => {
        return <BundleItem bundleService={dataItem.dataItem} />;
      };
    }

    if (field === 'servicesCount') {
      return (dataItem: any) => {
        return <CountItem bundleService={dataItem.dataItem} />;
      };
    }

    if (field === 'splitAmount') {
      return (dataItem: any) => {
        return <SplitAmount bundleService={dataItem.dataItem} />;
      };
    }
    if (field === 'bundlePrice') {
      return (dataItem: any) => {
        return <BundlePrice bundleService={dataItem.dataItem} />;
      };
    }
    if (field === 'invoiceAmount') {
      return (dataItem: any) => {
        return <InvoiceAmount bundleService={dataItem.dataItem} />;
      };
    }

    if (field === 'option') {
      return (dataItem: any) => {
        return <EditCell bundleService={dataItem.dataItem} />;
      };
    }
    // Return undefined if the field is not 'bluePrint'
    return undefined;
  };

  const closeDialog = () => {
    setIsOpen(false);
  };

  const submitHanlder = async () => {
    await deleteBundle();
    refetch();
    closeDialog();
  };

  // -------------------------------------------------Grid Layout------------------------------

  const {
    isLoading: isLoadingGridLayout,
    data: gridLayouts,
    refetch: refetchGridLayout
  } = useLoadData<ApiResponse<GridPreference>>(
    gridApiKeyStore.getGridLayout('UnitDetailServiceBundle', 'UnitDetailServiceBundle')
  );

  const { mutateAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
  const [gridConfig, setGridConfig] = useState<{
    dataState: State | undefined;
    columns: any[] | undefined;
  }>();

  const [filteredUnitServiceBundles, setFilteredUnitServiceBundles] = useState<Service[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const filteredUnitServiceBundleList = data?.data?.filter((UnitServiceBundle) =>
      Object.values(UnitServiceBundle).some(
        (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
    setFilteredUnitServiceBundles(filteredUnitServiceBundleList || []);
  }, [debouncedSearchTerm, data?.data]);

  const handleInputChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
    const data = {
      filterJSON: JSON.stringify(gridDataState),
      columnJSON: JSON.stringify(gridColumns),
      gridName: 'UnitDetailServiceBundle',
      pageName: 'UnitDetailServiceBundle',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  const handleResetLayout = () => {
    const data = {
      filterJSON: null,
      columnJSON: null,
      gridName: 'UnitDetailServiceBundle',
      pageName: 'UnitDetailServiceBundle',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  useEffect(() => {
    if (!gridLayouts?.data) return;

    try {
      const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

      const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

      // if (filterData && columnJson) {
      setGridConfig({
        columns: columnJson,
        dataState: filterData,
      });
      // }
    } catch (error) {
      console.log('Error parsing grid layout JSON:', error);
    }
  }, [gridLayouts?.data]);

  // ----------------------------------------------------------------------------------------

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <div className="borderTop">
      {!isCompleted && (
        <GuardedComponent requiredPermissions={[UserPermissionName.ADD_SERVICE_BUNDLE]}>
          <Button
            className="innerTab-button"
            size="small"
            variant="contained"
            disableElevation={true}
            onClick={handleOpenBundleDialog}
          >
            Add SERVICE BUNDLE
          </Button>
        </GuardedComponent>
      )}
      <SiTrackGrid
        fileTitle='unit_service'
        columns={!isCompleted ? columns : columns?.filter((column) => column?.field !== 'option')}
        dataItemKey="typeID"
        customCell={(field) =>
          CustomGridCell({
            field,
          })
        }
        showWithoutSorting={true}
        isBusy={isLoading || isLoadingGridLayout}
        footerCell={FooterCell}
        actionPermissions={{
          export: UserPermissionName.DOWNLOAD_GRID,
        }}

        // -----------------Grid Layout-------
        dataItems={filteredUnitServiceBundles || []}
        reorderable
        handleSearch={handleInputChange}
        handleSaveLayout={handleSaveLayout}
        isSaveLayout={true}
        gridConfigFromApi={gridConfig}
        handleResetLayout={handleResetLayout}
      // -----------------Grid Layout-------
      />
      {openServiceBundle && (
        <ServiceBundleDialog
          value={value}
          setValue={setValue}
          unitID={unitID}
          open={openServiceBundle}
          onClose={handleCloseBundleDialog}
          editItem={editItem}
          setEditItem={setEditItem}
          refetch={refetch}
        />
      )}
      {openServiceList && (
        <ServicesDetails splitID={splitID} open={openServiceList} onClose={() => setOpenServiceList(false)} />
      )}
      {isOpen && (
        <Dialog className="modalpopup" title={'CONFIRM DELETE'} onClose={closeDialog}>
          <div>
            <div style={{ padding: '25px 50px' }}>
              <div>Are you sure you want to permanently delete?</div>
              <LoadingIndicator isLoading={isLoadingBundle} />
              {/* <ApiErrorComponent isError={isError} errorRespnse={error} /> */}
            </div>
          </div>
          <DialogActionsBar>
            <div className=" spaceBetween">
              <button className="btn btn-sm btn-default btn-lightGrey" onClick={closeDialog} autoFocus>
                Cancel
              </button>
              <button
                className="btn btn-sm btn-danger btn-delete"
                type="button"
                style={{
                  backgroundColor: isReadOnlyPermission ? '#D7DBDD' : '#FF8A8A',
                  color: isReadOnlyPermission ? 'black' : '#fff'
                }}
                onClick={submitHanlder}
                disabled={isLoading || isReadOnlyPermission}
              >
                Delete
              </button>
            </div>
          </DialogActionsBar>
        </Dialog>
      )}
    </div>
    // <SiTrackGrid
    //   columns={columns}
    //   dataItemKey="serviceID"
    //   queryConfig={servicesApiKeyStore.getServiceOfficeMappings(unitID)}
    // />
  );
};
